'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'space-station-moon-construction';
var width = 512;
var height = 512;
var aliases = ["space-station-moon-alt"];
var unicode = 'e034';
var svgPathData = ['M16 256c0-132.5 107.5-240 240-240 67.1 0 127.8 27.6 171.4 72L360 88c-4.4 0-8 3.6-8 8-2.6 17.9-5.1 35.8-7.7 53.7-.2 .7-.3 1.5-.3 2.3l0 48c0 4.4 3.6 8 8 8l56 0 0 48c0 4.4 3.6 8 8 8l79.9 0c-.3 9.7-1.2 19.3-2.6 28.6-69.3 33.7-160.2 43.4-237.2 43.4-83.6 0-163.6-15.4-237.3-43.6-1.8-11.9-2.7-24-2.7-36.4zm6.3 54.8c72.9 26.7 151.6 41.2 233.7 41.2 42.6 0 89.9-2.9 136-11.3l0 43.3c0 4.4 3.6 8 8 8l53.8 0C410.5 454.8 338 496 256 496 142.3 496 47.1 416.9 22.3 310.8zM112 160a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z', 'M256 16c-132.5 0-240 107.5-240 240 0 12.4 .9 24.5 2.7 36.4 73.7 28.2 153.7 43.6 237.3 43.6 77 0 167.9-9.7 237.2-43.4 1.4-9.4 2.3-18.9 2.6-28.6L416 264c-4.4 0-8-3.6-8-8s3.6-8 8-8l88 0c4.4 0 8 3.6 8 8 0 14.8-1.3 29.2-3.7 43.3-.4 2.5-2 4.7-4.3 5.8-73.1 36.9-168.9 46.9-248.1 46.9-82.1 0-160.8-14.6-233.7-41.2 24.8 106.2 120 185.2 233.7 185.2 82 0 154.5-41.2 197.8-104L400 392c-4.4 0-8-3.6-8-8s3.6-8 8-8l68.5 0c2.9 0 5.5 1.6 7 4.1s1.4 5.6-.1 8.1C430.5 462.3 349 512 256 512 114.6 512 0 397.4 0 256S114.6 0 256 0c78.4 0 148.7 35.3 195.6 90.8 2 2.4 2.5 5.7 1.1 8.5s-4.1 4.6-7.3 4.6L360 104c-4.4 0-8-3.6-8-8s3.6-8 8-8l67.4 0C383.8 43.6 323.1 16 256 16zm88 136c0-4.4 3.6-8 8-8l96 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-96 0c-4.4 0-8-3.6-8-8zm0 48c0-4.4 3.6-8 8-8l96 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-96 0c-4.4 0-8-3.6-8-8zM192 224a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0-144a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSpaceStationMoonConstruction = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;